<template>
    <v-dialog
        :value="isOpen"
        max-width="500px"
        max-height="600px"
        transition="slide-y-transition"
        eager
        @keydown.esc="onAbort"
        @click:outside="onAbort"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    Przekierowanie
                </h1>
            </v-card-title>

            <v-card-text class="text-center">
                <v-select
                    v-model="accidentDepartmentId"
                    :items="accidentDepartments"
                    item-value="id"
                    no-data-text="Nie znaleziono działu"
                    label="Dział"
                >
                    <template slot="selection" slot-scope="data">
                        {{ data.item.name }}
                    </template>

                    <template slot="item" slot-scope="data">
                        {{ data.item.name }}
                    </template>
                </v-select>
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    :disabled="loading"
                    data-sentry-label="Anuluj"
                    @click="onAbort"
                >
                    Anuluj
                </v-btn>
                <v-spacer />
                <v-btn
                    color="success"
                    text
                    :loading="loading"
                    data-sentry-label="Potwierdź"
                    @click="saveAssignDepartment"
                >
                    Potwierdź
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

export default {
    name: 'AssignDepartmentDialog',
    props: {
        isOpen: {
            type: Boolean
        },
        accident: {
            type: Object,
            default: null
        },
        loading: {
            type: Boolean
        }
    },
    data() {
        return {
            accidentDepartmentId: null
        }
    },
    computed: {
        accidentTypes() {
            return this.$store.state.maintenance.accidents.accidentTypes
        },
        machines() {
            return this.$store.state.maintenance.accidents.machines
        },
        accidentDepartments() {
            return this.$store.state.maintenance.accidents.accidentDepartments
        },
    },
    watch: {
        accident(value) {
            this.accidentDepartmentId = value.accidentDepartmentId
        }
    },
    methods: {
        saveAssignDepartment() {
            this.$emit('save-assign-department', {
                updateType: 'department',
                accidentStatusId: 30, //redirected
                accidentDepartmentId: this.accidentDepartmentId
            })
        },
        onAbort() {
            this.accidentDepartmentId = this.accident.accidentDepartmentId
            this.$emit('close-assign-department-dialog')
        },
    }
}
</script>